import { render, staticRenderFns } from "./drive-thru.vue?vue&type=template&id=0c5eea4c"
import script from "./drive-thru.vue?vue&type=script&lang=js"
export * from "./drive-thru.vue?vue&type=script&lang=js"
import style0 from "./drive-thru.vue?vue&type=style&index=0&id=0c5eea4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Checkout: require('/home/ubuntu/complete-nuxt-js/components/checkout.vue').default})
